// Module
var code = "<style>:host{display:block;width:300px;height:200px;overflow:hidden}#canvas{height:100%;width:100%}</style> <canvas id=\"canvas\"></canvas>";
// Exports
export default code;